import React from 'react';
import { DataTestId } from '@utils/test';

export function SoldOut() {
  return (
    <div
      data-testid={DataTestId.SOLD_OUT_BADGE}
      className="line flex h-6 flex-shrink-0 items-center rounded-full bg-base900 px-2 font-base text-base-s font-semibold text-white"
    >
      Sold Out
    </div>
  );
}
